import { useTranslation } from "react-i18next";
import i18n from "src/i18n/config";
import { z } from "zod";

import { DownloadableFileModule, Product } from "@dashboard/products/types";

import { ModuleFileDialog, ModuleFileFormValues } from "../ModuleFileDialog";

const schema = z.object({
    fileId: z.string({ message: i18n.t("common:validation.fieldRequired") }),
});

type Props = {
    product: Product | null;
    module: DownloadableFileModule | null;
    open: boolean;
    onToggle: (value: boolean) => void;
};

export const DownloadableFileDialog = (props: Props) => {
    const { t } = useTranslation(["modals"]);

    return (
        <ModuleFileDialog<ModuleFileFormValues, DownloadableFileModule>
            product={props.product}
            module={props.module}
            open={props.open}
            onToggle={props.onToggle}
            title={t("modals:manageProductModules.downloadableFile.title")}
            description={t("modals:manageProductModules.downloadableFile.description")}
            noFilesAvailable={t("modals:manageProductModules.downloadableFile.noFilesAvailable")}
            schema={schema}
            newModuleDefaults={{ type: "downloadable_file", tags: ["Build"] }}
            buildModuleValues={(file, sourceId) => ({ name: file.filename, sourceId })}
        />
    );
};
